var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "item-filter-price" }, [
    _vm.priceSuggestionData
      ? _c(
          "div",
          { staticClass: "filter-container pb-3 d-flex flex-wrap showContent" },
          [
            typeof _vm.priceSuggestionData.valFirstMin === "number" &&
            _vm.priceSuggestionData.valFirstMax
              ? _c(
                  "button",
                  {
                    staticClass: "list-item d-flex align-items-center",
                    class: {
                      "filter-active":
                        _vm.priceMin !== "" &&
                        _vm.priceMin >= _vm.priceSuggestionData.valFirstMin &&
                        _vm.priceMax <= _vm.priceSuggestionData.valFirstMax,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.updatePrice(
                          _vm.priceSuggestionData.valFirstMin,
                          _vm.priceSuggestionData.valFirstMax
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.priceSuggestionData.valFirstMin
                          )
                        ) +
                        "\n      -\n      " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.priceSuggestionData.valFirstMax
                          )
                        ) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.priceSuggestionData.valSecondMin &&
            _vm.priceSuggestionData.valSecondMax
              ? _c(
                  "button",
                  {
                    staticClass: "list-item d-flex align-items-center",
                    class: {
                      "filter-active":
                        _vm.priceMin >= _vm.priceSuggestionData.valSecondMin &&
                        _vm.priceMax <= _vm.priceSuggestionData.valSecondMax,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.updatePrice(
                          _vm.priceSuggestionData.valSecondMin,
                          _vm.priceSuggestionData.valSecondMax
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.priceSuggestionData.valSecondMin
                          )
                        ) +
                        "\n      -\n      " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.priceSuggestionData.valSecondMax
                          )
                        ) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.priceSuggestionData.valThirdMin &&
            _vm.priceSuggestionData.valThirdMax
              ? _c(
                  "button",
                  {
                    staticClass: "list-item d-flex align-items-center",
                    class: {
                      "filter-active":
                        _vm.priceMin >= _vm.priceSuggestionData.valThirdMin &&
                        _vm.priceMax <= _vm.priceSuggestionData.valThirdMax,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.updatePrice(
                          _vm.priceSuggestionData.valThirdMin,
                          _vm.priceSuggestionData.valThirdMax
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.priceSuggestionData.valThirdMin
                          )
                        ) +
                        "\n      -\n      " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.priceSuggestionData.valThirdMax
                          )
                        ) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.priceSuggestionData.valFourthMin &&
            _vm.priceSuggestionData.valFourthMax
              ? _c(
                  "button",
                  {
                    staticClass: "list-item d-flex align-items-center",
                    class: {
                      "filter-active":
                        _vm.priceMin >= _vm.priceSuggestionData.valFourthMin &&
                        _vm.priceMax <= _vm.priceSuggestionData.valFourthMax,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.updatePrice(
                          _vm.priceSuggestionData.valFourthMin,
                          _vm.priceSuggestionData.valFourthMax
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.priceSuggestionData.valFourthMin
                          )
                        ) +
                        "\n      -\n      " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.priceSuggestionData.valFourthMax
                          )
                        ) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex align-items-center mb-3 facet-filter-price" },
      [
        _c("div", { staticClass: "input-group" }, [
          _c("div", { staticClass: "input-group-prepend" }, [
            _c("span", { staticClass: "input-group-text" }, [
              _vm._v(_vm._s(_vm.currency)),
            ]),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.priceMin,
                expression: "priceMin",
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "number",
              placeholder: "Min",
              "aria-label": _vm.$translate(
                "Ceres::Template.itemFilterPriceMin"
              ),
            },
            domProps: { value: _vm.priceMin },
            on: {
              focus: function ($event) {
                return _vm.selectAll($event)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.priceMin = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-group" }, [
          _c("div", { staticClass: "input-group-prepend" }, [
            _c("span", { staticClass: "input-group-text" }, [
              _vm._v(_vm._s(_vm.currency)),
            ]),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.priceMax,
                expression: "priceMax",
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "number",
              placeholder: "Max",
              "aria-label": _vm.$translate(
                "Ceres::Template.itemFilterPriceMax"
              ),
            },
            domProps: { value: _vm.priceMax },
            on: {
              focus: function ($event) {
                return _vm.selectAll($event)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.priceMax = $event.target.value
              },
            },
          }),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-primary w-100",
        class: { disabled: _vm.isDisabled },
        attrs: {
          type: "button",
          "aria-label": _vm.$translate("Ceres::Template.itemFilterButton"),
        },
        on: {
          click: function ($event) {
            return _vm.triggerFilter()
          },
        },
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$translate("Ceres::Template.itemApply")) +
            "\n  "
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }